import React from 'react';

function ApplicationContainer(props) {
  return (
    <div className="virtual-body navbar-top-custom">
      <div className="page-content">
        <div className="content-wrapper rounded-2 ml-2 mr-2 mt-4">
          <nav aria-label="breadcrumb " style={{ background: '#9e9e9e42' }}>
            <ol className="breadcrumb">
              <li className="breadcrumb-item active ml-2" aria-current="page">
                {props.title}
              </li>
            </ol>
          </nav>
          <div className="content">{props.children}</div>
        </div>
      </div>
    </div>
  );
}

export default ApplicationContainer;
